import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DateTime } from 'luxon'
import { useFormikContext } from 'formik'
import LegacyUserDropdown from '../../../Dropdown/LegacyUserDropdown'
import { getDropdownProps } from '../../../../helpers/formHelper'
import FormikDateRange from '../../../../components/Formik/Date/FormikDateRange'
import { Stack } from '@fluentui/react'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'

export type WipReportDto = {
    from: string
    to: string
    timeOwners: string[]
    fileOwners: string[]
}

function ReportBody(): ReactElement {
    const context = useFormikContext<WipReportDto>()
    const { errors, values, setFieldValue } = context
    return (
        <Stack>
            <FormikDateRange context={context} startName="from" endName="to" />
            <LegacyUserDropdown
                label="Dossierverantwoordelijke"
                {...getDropdownProps(
                    values.fileOwners,
                    errors?.fileOwners,
                    value => setFieldValue('fileOwners', value),
                    true,
                )}
                required={false}
            />
            <LegacyUserDropdown
                label="Uitvoerder"
                {...getDropdownProps(
                    values.timeOwners,
                    errors?.timeOwners,
                    value => setFieldValue('timeOwners', value),
                    true,
                )}
                required={false}
            />
        </Stack>
    )
}

export default function WipReportForm(): ReactElement {
    return (
        <ReportForm<WipReportDto>
            title="Onderhanden werk"
            generationType={DocumentGenerationType.WipPosition}
            initialValues={{
                from: DateTime.local().minus({ months: 12 }).startOf('month').toISODate(),
                to: DateTime.local().toISODate(),
                timeOwners: [],
                fileOwners: [],
            }}
        >
            <ReportBody />
        </ReportForm>
    )
}
